import rechargeIndex from '@/pages/recharge/index.vue'
import rechargeList from '@/pages/recharge/rechargeList.vue'
import rechargeClass from '@/pages/recharge/rechargeClass.vue'

const appRoutes = [{
	path: '/recharge',
	redirect: '/recharge/rechargeClass',
	component: rechargeIndex,
	children: [{
		path: 'rechargeList',
    name: 'rechargeList',
		component: rechargeList
	},{
		path: 'rechargeClass',
    name: 'rechargeClass',
		component: rechargeClass
	}]
}]
export default appRoutes
